import { GET_USER_EMAIL_REQUEST, GET_USER_EMAIL_SUCCESS, GET_USER_EMAIL_FAILURE } from '../../constants/user_emails.constants';

export const getUserEmailRequest = id => ({ type: GET_USER_EMAIL_REQUEST, id });
export const getUserEmailRequestSuccess = payload => ({ type: GET_USER_EMAIL_SUCCESS, payload });
export const getUserEmailRequestFailure = error => ({ type: GET_USER_EMAIL_FAILURE, error });



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/user_emails_actions/get_user_email.actions.js